<template>
  <div class="finance-config">
    <div class="title">
      <span>资产配置</span>
      <div class="clearfix">
        <i @click="$refs.assets.generatingReports()">生成报告</i>
        <i @click="handleOpen">查看历史</i>
        <i>加入待办</i>
      </div>
    </div>
    <div class="custom-info">
      <el-row>
        <el-col :span="12">
          <section>
            <p class="info-left">
              <span>{{customer.custName}}</span>
              <img :src="custImg.custLevel"
                   alt="custLevel" />
              <img :src="custImg.custGender"
                   alt="custGender"
                   v-if="customer.gender==='1'" />
              <img :src="custImg.custGenderTwo"
                   alt="custGender"
                   v-if="customer.gender==='2'" />
              <span>{{customer.age}}岁</span>
              <span>{{customer.riskLevelRes}}</span>
            </p>
            <p>
              <span>手机号码：{{customer.mobileNumber|encryptPhone}}</span>
              <img :src="custImg.custMessage"
                   alt="custMessage" />
              <img :src="custImg.custPhone"
                   alt="custPhone" />
            </p>
          </section>
        </el-col>
        <el-col :span="12">
          <div class="info-right">
            <p v-if="familyRelations.length!==0">
              <span class="right-title">家庭成员：</span>
              <el-tooltip class="item"
                          effect="dark"
                          :content="familyRelations"
                          placement="top">
                <span>{{familyRelations|formatName}}</span>
              </el-tooltip>

            </p>
            <p v-else>
              <span class="right-title">家庭成员：</span>无
            </p>
            <p v-if="finList.length!==0">
              <span class="right-title">金融特征：</span>
              <i class="financeTab"
                 v-for="item in finList"
                 :key="item">{{item.labelValueName}}</i>
            </p>
            <p v-else>
              <span class="right-title">金融特征：</span>无
            </p>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="title lineHight">
      <span class="t2">优化方案建议</span>
      <div class="clearfix">
        <img :src="custImg.custEdit"
             alt="custEdit" />
        <span class="button--blue"
              @click="Analysis">完善客户信息</span>
      </div>
    </div>
    <div class="mian-info">
      <el-tabs v-model="activeName">
        <el-tab-pane label="标准"
                     name="0">
          <assetAllocationScheme v-if="activeName==='0'"
                                 :riskLevel="riskLevel"
                                 tabs="1"
                                 ref="assets"></assetAllocationScheme>
        </el-tab-pane>
        <el-tab-pane label="提收益"
                     name="1">
          <assetAllocationScheme v-if="activeName==='1'"
                                 :riskLevel="riskLevel"
                                 tabs="2"
                                 ref="assets"></assetAllocationScheme>
        </el-tab-pane>
        <el-tab-pane label="降风险"
                     name="2">
          <assetAllocationScheme v-if="activeName==='2'"
                                 :riskLevel="riskLevel"
                                 tabs="3"
                                 ref="assets"></assetAllocationScheme>
        </el-tab-pane>
      </el-tabs>
      <section>
        <p class="footer">
          <el-button type="plain"
                     style="margin-right:25px"
                     @click="$refs.assets.default()">默认配置</el-button>
          <el-button type="primary"
                     @click="$refs.assets.generatingReports()">生成报告</el-button>
        </p>
      </section>
    </div>
    <el-dialog title="历史配置"
               :visible.sync="dialogVisible"
               width="50%"
               :before-close="handleClose"
               :close-on-click-modal='false'>
      <el-table :data="tableData"
                header-row-class-name="grey-header"
                border>
        <el-table-column prop="createTime"
                         label="配置时间">
          <template slot-scope="scope">
            {{scope.row.createTime|formatTime}}
          </template>
        </el-table-column>
        <el-table-column prop="operatorName"
                         label="操作人"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="button--blue"
                  @click="onDownloadClick(scope.row)">下载</span>
            <span class="button--blue"
                  @click="onDetailClick(scope.row)">查看</span>
          </template>
        </el-table-column>
      </el-table>
      <yh-pagination :page.sync="currentPage"
                     :total="sumCount" />
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { getFunctionList, addNav, getPagingData } from "@/mixins";
import tableCom from "./table-com";
import assetAllocationScheme from "./assetAllocationScheme";
const RED = "#e07d82";
const GREEN = "#6cbba1";
export default {
  name: "finance-config",
  components: { tableCom, assetAllocationScheme },
  mixins: [getFunctionList, addNav, getPagingData],
  data() {
    return {
      activeName: "0",
      finList: [],
      custImg: {
        custMessage: require("@/assets/images/finance-config/message-2x.png"),
        custPhone: require("@/assets/images/finance-config/phone-2x.png"),
        custLevel: require("@/assets/images/finance-config/sliver-2x.png"),
        custGender: require("@/assets/images/finance-config/man-arrow-2x.png"),
        custGenderTwo: require("@/assets/images/finance-config/woman-arrow-2x.png"),
        custEdit: require("@/assets/images/finance-config/edit.png"),
        custCompare: require("@/assets/images/finance-config/double-arrow-right.png"),
        compareRight: require("@/assets/images/finance-config/arrowright.png"),
        arrowdown: require("@/assets/images/finance-config/arrowdown-green.png"),
        arrowup: require("@/assets/images/finance-config/arrowup-red.png"),
      },
      // 总数
      sumCount: 0,
      // 当前页数
      currentPage: 1,
      // 每页数量
      pageSize: 10,
      dialogVisible: false,
      tableData: [],
      riskLevel: JSON.parse(
        sessionStorage.getItem("customer")
      ).riskLevel.replace(/C/g, "R"),
      // riskLevel: 'R4',
      customer: JSON.parse(sessionStorage.getItem("customer")), // 客户信息
      familyRelations: [],
    };
  },
  created() {},
  computed: {},
  filters: {
    formatName(v) {
      if (v.length >= 30) {
        return `${v.slice(0, 30)}...`;
      }
      return v;
    },
  },
  mounted() {
    this.queryDefaultRelation();
    this.queryCustomer();
    // this.custConfigCreate();
    this.createCustmerView();
  },
  methods: {
    // 查询客户是否保存过方案
    queryCustomer() {
      const parames = {
        data: {
          cis: this.customer.cis,
          custRiskLevel: this.customer.riskLevel,
          scheme: this.activeName,
          riskPreference: this.riskLevel.replace(/R/g, ""),
        },
      };
      this.$_post(this.$API.queryCustomer, parames).then((res) => {
        this.activeName = res.data.info.scheme;
      });
    },
    // 家庭关系
    queryDefaultRelation() {
      const parames = {
        data: {
          // 类型：Object  必有字段  备注：数据集
          cis: this.customer.cis, // 类型：String  必有字段  备注：客户号
          uId: JSON.parse(sessionStorage.getItem("sessionData")).userId,
        },
      };
      this.$_post(this.$API.wpspListCustSupple, parames).then((res) => {
        this.familyRelations = "";
        for (let i = 0; i < res.data.allCustSupple.length; i++) {
          this.familyRelations =
            this.familyRelations +
            this.familyRelationship(res.data.allCustSupple[i].custRelation) +
            "-" +
            res.data.allCustSupple[i].custName;
          if (i !== res.data.allCustSupple.length - 1) {
            this.familyRelations = this.familyRelations + "、";
          }
        }
        console.log(this.familyRelations, "this.familyRelations ");
      });
    },
    familyRelationship(x) {
      let i = "";
      switch (x) {
        case "0":
          i = "本人";
          break;
        case "1":
          i = "配偶";
          break;
        case "2":
          i = "父亲";
          break;
        case "3":
          i = "母亲";
          break;
        case "4":
          i = "儿子";
          break;
        case "5":
          i = "女儿";
          break;
        case "6":
          i = "配偶父亲";
          break;
        case "7":
          i = "配偶母亲";
          break;
        default:
          break;
      }
      return i;
    },
    // 金融特征
    createCustmerView() {
      const parames = {
        data: {
          custId: JSON.parse(sessionStorage.getItem("sessionData")).userId,
        },
      };
      this.$_post(this.$API.createCustmerView, parames).then((res) => {
        if (res.data !== undefined) {
          this.finList = res.data.金融特征;
        }
      });
    },
    // 跳转资产分析
    Analysis() {
      this.addNav({
        name: "客户视图",
        path: "/CustomerView",
        query: {},
      });
    },
    // 保存风险等级及tab
    custConfigCreate() {
      const parames = {
        data: {
          cis: this.customer.cis,
          custRiskLevel: this.customer.riskLevel,
          scheme: this.activeName,
          riskPreference: this.riskLevel.replace(/R/g, ""),
        },
      };
      this.$_post(this.$API.cust_config_create, parames).then((res) => {
        console.log(res);
      });
    },

    // 下载
    onDownloadClick(row) {
      const parames = {
        data: {
          id: row.id,
        },
      };
      this.$_post(this.$API.historyDetail, parames).then((res) => {
        // window.open(res.data.info);
        // window.location.href=res.data.info;
        this.downloadReport(res.data.info);
      });
    },
    downloadReport(row) {
      const aTag = document.createElement("a");
      aTag.download = "aa";
      aTag.style.display = "none";
      aTag.href = row;
      document.body.appendChild(aTag);
      aTag.click();
      document.body.removeChild(aTag);
    },
    // 查看
    onDetailClick(row) {
      const parames = {
        data: {
          id: row.id,
        },
      };
      this.$_post(this.$API.historyDetail, parames).then((res) => {
        window.open(res.data.info);
      });
    },
    // 打开历史配置
    handleOpen() {
      const parames = {
        pageMessage: {
          pageSize: 10,
          pageNo: this.pageNum,
        },
        data: {
          cis: JSON.parse(sessionStorage.getItem("customer")).cis,
        },
      };
      this.$_post(this.$API.historyList, parames).then((res) => {
        this.tableData = res.data.list;
        this.dialogVisible = true;
        this.sumCount = res.sumCount;
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.finance-config {
  width: 1627px;
  .el-tabs__nav-scroll {
    display: flex;
    justify-content: center;
  }
  .mian-info {
  }
}
.per-num {
  display: inline-block;
  font-weight: bold;
  // letter-spacing: 0.6px;
  width: 100px;
  font-size: 16px;
  color: rgba(48, 49, 51, 1);
}
.direction-left {
  text-align: left;
}
.direction-right {
  text-align: right;
}

.info-left {
  img {
    width: 20px;
    height: auto;
    margin-right: 10px;
  }
  span {
    font-size: 14px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: rgba(48, 49, 51, 1);
    margin-right: 10px;
  }
  span:first-child {
    font-size: 24px;
    color: rgba(30, 136, 255, 1);
    letter-spacing: 1.6px;
  }
  + p {
    font-size: 14px;
    font-weight: 500;
    color: rgba(144, 147, 153, 1);
    margin-top: 10px;
    span {
      display: inline-block;
      transform: translateY(-5px);
    }
    img {
      width: 24px;
      height: auto;
      margin-left: 10px;
    }
  }
}

.title {
  span:first-child {
    width: 146px;
    height: 20px;
    font-size: 20px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: bold;
    color: rgba(48, 49, 51, 1);

    // line-height:30px;
  }
  div {
    float: right;
    i {
      font-style: normal;
      text-align: center;
      display: inline-block;
      width: 84px;
      height: 30px;
      background: rgba(30, 136, 255, 1);
      border-radius: 4px;
      // width: 56px;
      // height: 14px;
      font-size: 14px;
      font-family: SourceHanSansCN-Normal, SourceHanSansCN;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 30px;
      margin-left: 12px;
    }
  }
}
.custom-info {
  padding: 7px 30px;
  margin-top: 20px;
  box-sizing: border-box;
  width: 100%;
  height: 96px;
  background: rgba(250, 251, 252, 1);
  box-shadow: 0px 3px 6px 0px rgba(192, 196, 204, 0.38);
  border-radius: 4px;
}
.financeTab {
  font-style: normal;
  text-align: center;
  display: inline-block;
  width: 73px;
  height: 24px;
  background: rgba(237, 246, 255, 1);
  border-radius: 12px;
  font-size: 12px;
  color: rgba(30, 136, 255, 1);
  line-height: 24px;
  letter-spacing: 0.4px;
}
.info-right {
  p {
    height: 31px;
    font-size: 14px;
    letter-spacing: 0.4px;
    color: rgba(96, 98, 102, 1);
    padding-top: 10px;
    box-sizing: border-box;
    .right-title {
      color: rgba(144, 147, 153, 1);
    }
  }
}
.t2 {
  font-size: 16px !important;
}
.lineHight {
  margin-top: 30px;
  height: 30px;
  line-height: 30px;
  img {
    transform: translate(-4px, 4px);
  }
}
.main-info {
  border: 1px solid red;
  margin: 2px;
}
.center {
  height: 237px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.clearfix > i {
  cursor: pointer;
}
.type-circle {
  width: 12px;
  height: 12px;
  display: inline-block;
  margin-right: 10px;
  border-radius: 50%;
  + span {
    color: rgba(96, 98, 102, 1);
    letter-spacing: 0.6px;
  }
}
.compare-charts {
  position: relative;
  left: 130px;
  top: -45px;
  > div {
    margin-bottom: 15px;
  }
}
.tips {
  width: 30px;
  height: 30px;
  background: rgba(30, 136, 255, 0.2);
  border-radius: 2px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #1e88ff;
  line-height: 30px;
  display: inline-block;
  margin-right: 10px;
  float: right;
  + span {
    > i {
      font-style: normal;
      font-weight: bold;
    }
  }
}
.right-title {
  font-size: 14px;
  color: rgba(48, 49, 51, 1);
  font-weight: bold;
  margin-bottom: 10px;
}
.footer {
  margin-top: 45px;
  text-align: center;
}
.show-strong {
  font-style: normal;
  font-weight: bold;
  color: red;
}
.grey-header {
  th {
    background: #f5f7fa;
  }
}
</style>
<style>
.finance-config .el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}
.finance-config .el-tabs__item {
  font-size: 16px;
}
</style>
